/** @jsxImportSource @emotion/react */

import React, { FC, useEffect, useRef, useState } from "react";
import { Badge, BadgeAnchor } from "rmwc";
import Icon from "../Icon";
import { Link } from "react-router-dom";
import Text from "ui-modules/components/DataDisplay/Text";
import { css } from "@emotion/core";
import useTheme from "ui-modules/commons/hooks/use-theme";

type TopAppBarNotificationProps = {
  messages?: Record<any, any>[];
  readAllNotification?: boolean;
};

const TopAppBarNotification: FC<TopAppBarNotificationProps> = (props) => {
  const theme = useTheme();
  const { messages = [], readAllNotification } = props;

  const wrapperRef = useRef<any>(null);

  const [notificationShow, setNotificationShow] = useState(false);

  useEffect(() => {
    if (notificationShow) {
      document.addEventListener("mouseup", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationShow]);

  const handleClickOutside = (e?: Event) => {
    if (wrapperRef?.current && !wrapperRef.current?.contains(e?.target)) {
      setNotificationShow(false);
    }
  };

  const styles = {
    notificationTopBarBox: css`
      background: ${theme.bodyBackground};
      padding: 15px;
      border-radius: 4px;
      position: absolute;
      left: 20px;
      box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      text-align: center;
      cursor: default;
      width: 25%;
      @media (max-width: 992px) {
        width: 95%;
      }
    `,
    lastUnReadMessages: css`
      background: ${theme.material.background};
      border-radius: 4px;
      border-right: 5px solid ${theme.material.primary};
      padding: 1px 12px;
      text-align: right;
      margin-bottom: 10px;
    `,
    noMessage: css`
      background: ${theme.material.background};
      border-radius: 4px;
      padding: 12px;
    `,
    badgeStyle: css`
      background: ${theme.material.primary};
      padding: 2px;
      left: 5px;
      top: 5px;
    `,
  };

  return (
    <div ref={wrapperRef}>
      <div
        onClick={() => {
          setNotificationShow((prevState) => !prevState);
        }}
      >
        {messages.length === 0 || readAllNotification ? (
          <Icon name={"bell"} className={"drawerIcons large"} />
        ) : (
          <BadgeAnchor>
            <Icon name={"bell"} className={"drawerIcons large"} />
            <Badge align={"start"} css={styles.badgeStyle} />
          </BadgeAnchor>
        )}
      </div>
      <div css={styles.notificationTopBarBox} style={{ display: notificationShow ? "block" : "none" }}>
        {messages.length > 0 && !readAllNotification ? (
          <>
            {messages?.map((msg) => {
              let message;
              try {
                const messageParse = JSON.parse(msg?.content);
                message = messageParse?.message;
              } catch (e) {}

              if (!message) return null;
              return (
                <div key={msg.id}>
                  <Link to={"/notifications"} onClick={() => setNotificationShow(false)}>
                    <Text type={"paragraph"} css={styles.lastUnReadMessages}>
                      <pre style={{ marginRight: 5, whiteSpace: "pre-wrap" }}>{`${message.substr(0, 150)}...`}</pre>
                    </Text>
                  </Link>
                </div>
              );
            })}
            <Link to={"/notifications"} onClick={() => setNotificationShow(false)}>
              <div style={{ color: "#22A9D4" }}>مشاهده بیشتر</div>
            </Link>
          </>
        ) : (
          <Text type={"paragraph"} css={styles.noMessage}>
            مشترک گرامی، اعلان جدیدی برای نمایش وجود ندارد.
          </Text>
        )}
      </div>
    </div>
  );
};

export default TopAppBarNotification;
